import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useShare } from '../context/ShareContext';
import { useCommunity } from '../context/CommunityContext';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const FavoriteButton = ({ targetType, targetId, className = '', label = true }) => {
  const { user } = useShare();
  const { favoriteKeys, toggleFavorite, featureAvailable } = useCommunity();
  const navigate = useNavigate();
  const [saving, setSaving] = useState(false);
  const active = favoriteKeys.has(`${targetType}:${targetId}`);

  const handleClick = async (event) => {
    event.preventDefault();
    event.stopPropagation();

    if (!user) {
      navigate('/auth');
      return;
    }

    setSaving(true);
    try {
      await toggleFavorite(targetType, targetId);
    } catch (error) {
      alert(error.message || 'Das Angebot konnte nicht gespeichert werden.');
    } finally {
      setSaving(false);
    }
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      disabled={saving || !featureAvailable}
      title={active ? 'Aus Merkliste entfernen' : 'Für später merken'}
      aria-pressed={active}
      className={`inline-flex items-center justify-center gap-1.5 rounded-xl border px-3 py-2 text-sm font-bold transition-colors disabled:opacity-50 ${
        active
          ? 'bg-rose-50 text-rose-700 border-rose-200 hover:bg-rose-100'
          : 'bg-white/95 text-gray-700 border-gray-200 hover:bg-gray-50'
      } ${className}`}
    >
      <SafeIcon icon={active ? FiIcons.FiHeart : FiIcons.FiBookmark} className={active ? 'fill-current' : ''} />
      {label && <span>{active ? 'Gemerkt' : 'Merken'}</span>}
    </button>
  );
};

export default FavoriteButton;
